import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigSettingsParagraphDirective } from '../configuration/configSettingsParagraph.directive';
import { ConfigSettingsBackgroundDirective } from '../configuration/configSettingsBackground.directive';
import { ConfigSettingsTitleDirective } from '../configuration/configSettingsTitle.directive';
import { ConfigSettingsDirective } from '../configuration/configSettingsInput.directive';
import { ConfigSettingsSecondTitleDirective } from '../configuration/configSettingsSecondTitle.directive';
import { ConfigSettingsBorderDirective } from '../configuration/configSettingsBorder.directive';
import { ConfigSettingsButtonDirective } from '../configuration/configSettingsButton.directive';
import { ConfigSettingsPrimaryButtonDirective } from "../configuration/configSettingsPrimaryButton.directive";

@NgModule({
  declarations: [
    ConfigSettingsParagraphDirective,
    ConfigSettingsBackgroundDirective,
    ConfigSettingsTitleDirective,
    ConfigSettingsDirective,
    ConfigSettingsSecondTitleDirective,
    ConfigSettingsBorderDirective,
    ConfigSettingsButtonDirective,
    ConfigSettingsPrimaryButtonDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ConfigSettingsBackgroundDirective,
    ConfigSettingsParagraphDirective,
    ConfigSettingsTitleDirective,
    ConfigSettingsDirective,
    ConfigSettingsSecondTitleDirective,
    ConfigSettingsBorderDirective,
    ConfigSettingsButtonDirective,
    ConfigSettingsPrimaryButtonDirective,
  ]
})
export class CommonDirectivesModule { }
